var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { MoreHoriz } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
var OrderActionsMenu = function (_a) {
    var item = _a.item, menuAnchorEl = _a.menuAnchorEl, selectedOrder = _a.selectedOrder, onMenuClick = _a.onMenuClick, onMenuClose = _a.onMenuClose, _b = _a.orderIdField, orderIdField = _b === void 0 ? "OrderId" : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, menuItems = _a.menuItems, _d = _a.emptyState, emptyState = _d === void 0 ? _jsx("div", __assign({ className: "ST_emptyInvoiceIcon" }, { children: "-" })) : _d, _e = _a.showMenu, showMenu = _e === void 0 ? true : _e;
    var t = useTranslation().t;
    var orderId = item[orderIdField];
    var selectedOrderId = selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder[orderIdField];
    var isOpen = Boolean(menuAnchorEl) && selectedOrderId === orderId;
    // Filter menu items based on show condition
    var visibleMenuItems = menuItems.filter(function (menuItem) { return menuItem.show !== false; });
    if (!showMenu || visibleMenuItems.length === 0) {
        return _jsx(_Fragment, { children: emptyState });
    }
    return (_jsxs(_Fragment, { children: [_jsx(IconButton, __assign({ size: "small", onClick: function (e) { return onMenuClick(e, item); }, sx: { padding: "4px" }, disabled: disabled, "aria-label": t("yourSales_Action") }, { children: _jsx(MoreHoriz, { fontSize: "small" }) })), _jsx(Menu, __assign({ anchorEl: menuAnchorEl, open: isOpen, onClose: onMenuClose, anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right",
                }, transformOrigin: {
                    vertical: "top",
                    horizontal: "right",
                }, disableScrollLock: true, disablePortal: false, disableAutoFocusItem: true, MenuListProps: {
                    "aria-labelledby": "action-button",
                } }, { children: visibleMenuItems.map(function (menuItem, index) { return (_jsx(MenuItem, __assign({ onClick: menuItem.onClick, disabled: menuItem.disabled, className: menuItem.className }, { children: menuItem.label }), index)); }) }))] }));
};
export default OrderActionsMenu;
